import React, { useEffect, useState } from "react";
import Service from "../../Service/http";
import * as xlsx from "xlsx";
import { Link } from "react-router-dom";
import { FcDownload } from "react-icons/fc";
import { toast } from "react-toastify";

const SincerityScoreUpload = () => {
    let [data, SetData] = useState(null);
    const service = new Service();
    let [loading, setLoading] = useState(false);
    
    const handleFeedbackUpload = async () => {
        setLoading(true);
        if (!data) {
            toast.error("No File is Chosen");
            setLoading(false)
            return;
        }
        if (!(await checkDataValidiTy(data))) {
            toast.error("Scores of Some Users are not as Per Expected");
            setLoading(false);
            return;
        }
        service
            .post("api/users/bulkupdate/feeback", { data: data })
            .then((json) => {
                setLoading(false);
                downloadExcel(json.responseData)
                toast.success("Added FollowUp To Users");
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
                toast.error("Error");
            });
    };
    const checkDataValidiTy = async (studentFeedbackList) => {
        let acceptableScoress = [-5, -3, -2, -1, 0, 1, 2, 3, 5];

        for (let userHandle of studentFeedbackList) {
            if (!acceptableScoress.includes(userHandle.Score)) {
                return false;
            }
        }
        return true;
    };

    function downloadExcel(jsonData) {
        const options = { timeZone: "Asia/Kolkata" }; // Set the time zone to India
        const formattedDate = new Date().toLocaleDateString("en-IN", options);
        const fileName = "response" + formattedDate;
    
        // Convert JSON to worksheet
        const ws = xlsx.utils.json_to_sheet(jsonData);
    
        // Create a workbook
        const wb = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(wb, ws, "Sheet 1");
    
        // Save the workbook to a file
        xlsx.writeFile(wb, `${fileName}.xlsx`);
      }

    const handleFileUpload = (e) => {
        e.preventDefault();
        if (e.target.files) {
            setLoading(true);
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = e.target.result;
                const workbook = xlsx.read(data, { type: "array" });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const json = xlsx.utils.sheet_to_json(worksheet);
                SetData(json);
            };
            
            if(e.target.files[0])
                reader.readAsArrayBuffer(e.target.files[0]);
            else {
                setLoading(false)
                toast.error("No File is Chosen");
                SetData(null)
            }
        }
    };

        useEffect(() => {
            if(data) {
                if(loading) toast.success("File Uploaded Successfully")
                setLoading(false)
            } else {
                setLoading(false)
            }
        }, [data]);

    return (
        <div className="card">
            <div
                className="card-title text-primary"
                style={{ textAlign: "center", margin: "2%" }}
            >
                <h3>Bulk Upload Students Feedback/FollowUp</h3>
            </div>
            <div className="card-body">
                <div>
                    <text className="card-text" style={{ margin: "2%", color: "red" }}>
                        {" "}
                        Note :
                        <ul>
                         <li>Score must be among these Values [-5,-3,-2,-1,0,1,2,3,5] any
                         other Score value will become 0.</li>
                         <li>Leaderboard is cached.</li>
                         <li>To check the sincerity score immediately: - search the user in the users page & verify it by seeing "Pts" column which represents sincerity score.</li>
                        </ul>
                    </text>
                    <Link
                        className="float-start"
                        to="/files/student-feedback.xlsx"
                        target="_blank"
                        download
                    >
                        {" "}
                        <FcDownload /> Download Sample{" "}
                    </Link>
                </div>
                <br />

                <div className=" my-2">
                    <input
                        className="form-control"
                        type="file"
                        placeholder="Upload to pre create user"
                        accept=".csv,.xlsx,.xls"
                        onChange={handleFileUpload}
                    />
                </div>

                <div>
                    <button
                        disabled={loading}
                        onClick={() => {
                            handleFeedbackUpload();
                        }}
                        className= {loading || !data ? "btn btn-secondary m-2 mx-2 float-end" : "btn btn-success m-2 mx-2 float-end cursor-pointer"}
                    >
                        {loading ? "Uploading ..." : "Upload Data"}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default SincerityScoreUpload